import { useCallback } from "react";
import { useForm } from "react-hook-form";

import useMutate from "../../../../hooks/useMutate";
import { useSettingsDirtyState } from "./useSettingsDirtyState";

export function useSimpleSettingsForm({
  initialData,
  mutationFn,
  invalidateKeys,
  transformSubmitData,
}) {
  const methods = useForm({
    defaultValues: initialData,
  });
  const { mutate, isPending } = useMutate(mutationFn, invalidateKeys);
  const { hasChanges } = useSettingsDirtyState(methods, initialData);

  const onSubmit = useCallback(
    (formData) => {
      mutate(transformSubmitData ? transformSubmitData(formData) : formData);
    },
    [mutate, transformSubmitData]
  );

  return {
    methods,
    isPending,
    hasChanges,
    onSubmit,
  };
}
